import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MediumHeader } from '@narvar/nth-header';
import { formatCurrencyValue } from '../../../lib/currencyFormatters';

const mapStateToProps = ({ language, page: { locale } }) => ({
  language,
  locale,
});

const StyledSubtitle = styled.span`
  color: #7a7a7a;
  margin-bottom: 1.5rem;
  display: block;
`;

const StripeHeader = ({ language, id, serviceFee, locale }) => (
  <div style={{ textAlign: 'center' }}>
    <MediumHeader s={{ fontSize: '1rem' }}>
      {(language[`returns.stripe.${id}.title`] || language[`returns.stripe_title`]).replace(
        '{fee}',
        formatCurrencyValue({
          value: serviceFee,
          locale,
        }),
      )}
    </MediumHeader>
    <StyledSubtitle>
      {(language[`returns.stripe.${id}.subtitle`] || language[`returns.stripe_subtitle`]).replace(
        '{fee}',
        formatCurrencyValue({
          value: serviceFee,
          locale,
        }),
      )}
    </StyledSubtitle>
  </div>
);

StripeHeader.propTypes = {
  language: PropTypes.object.isRequired,
  serviceFee: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(StripeHeader);
